var h = Object.defineProperty;
var o = (e, s, t) => s in e ? h(e, s, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[s] = t;
var n = (e, s, t) => (o(e, typeof s != "symbol" ? s + "" : s, t), t);
class l {
  constructor() {
    n(this, "events", {});
  }
  on(s, t) {
    this.events[s] || (this.events[s] = []), this.events[s].push(t);
  }
  emit(s, t) {
    const i = this.events[s];
    if (i)
      for (const f of i)
        f(t);
  }
  off(s, t) {
    this.events[s] && (this.events[s] = this.events[s].filter((i) => i !== t));
  }
}
export {
  l as EventEmitter
};
//# sourceMappingURL=eventEmitter.es.js.map
